import React, { FC } from 'react';
import {
	SummaryBeantragteFoerderquote,
	SummaryBeantragteFoerderung,
	SummaryDatumDerEinreichung,
	SummaryGeplanteProjektAusgabe,
	SummaryGeplanteProjektLaufzeit,
	SummaryNameDerOrganisation,
	SummaryOrganisationAntragberechtigtAls,
	SummaryOrganisationFoerderQuote,
	SummaryProjektTitel,
	SummaryTitel,
	SummaryVerbundpartnerDetails,
	SummaryVorzeitigerVorhabenBeantragt,
	SummaryVorzeitigerVorhabenLaufzeit,
} from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteSummary';
import AbschlussSeiteBox from '../../../../antrag-components/AbschlussSeiteBox';

const AbschlussSkizzeLoewe: FC<{}> = () => {
	return (
		<>
			<SummaryTitel />
			<AbschlussSeiteBox>
				<SummaryDatumDerEinreichung />

				<SummaryProjektTitel />
				<SummaryGeplanteProjektLaufzeit />

				<SummaryNameDerOrganisation />
				<SummaryOrganisationAntragberechtigtAls />

				<SummaryOrganisationFoerderQuote />

				<SummaryVerbundpartnerDetails />

				<SummaryVorzeitigerVorhabenBeantragt />
				<SummaryVorzeitigerVorhabenLaufzeit />

				<SummaryGeplanteProjektAusgabe />
				<SummaryBeantragteFoerderung />
				<SummaryBeantragteFoerderquote />
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussSkizzeLoewe;
